export default __webpack_public_path__ + "static/blog-img11-f2b91691d9e3b41ad4346cddb821aa65.jpg";